function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "receipt",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M59,8v53l-4.25-3-4.25,3-4.24-3-4.25,3-4.25-3-4.25,3-4.26-3-4.25,3V8c0-1.38-.56-2.63-1.46-3.54-.91-.9-2.16-1.46-3.54-1.46h34c2.76,0,5,2.24,5,5Z",
    style: {
      strokeWidth: 0,
      fill: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,8v31h-15c2.76,0,5-2.24,5-5V8c0-2.76,2.24-5,5-5,1.38,0,2.63.56,3.54,1.46.9.91,1.46,2.16,1.46,3.54Z",
    style: {
      fill: "#6293f2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,21v13c0,2.76-2.24,5-5,5-1.38,0-2.63-.56-3.54-1.46-.9-.91-1.46-2.16-1.46-3.54v-13h10Z",
    style: {
      strokeWidth: 0,
      fill: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,21v2c0,.55.45,1,1,1s1-.45,1-1v-2h1c1.65,0,3-1.35,3-3s-1.35-3-3-3h-1v-2h3c.55,0,1-.45,1-1s-.45-1-1-1h-3v-2c0-.55-.45-1-1-1s-1,.45-1,1v2h-1c-1.65,0-3,1.35-3,3s1.35,3,3,3h1v2h-3c-.55,0-1,.45-1,1s.45,1,1,1h3ZM40,15c-.55,0-1-.45-1-1s.45-1,1-1h1v2h-1ZM43,17h1c.55,0,1,.45,1,1s-.45,1-1,1h-1v-2Z",
    style: {
      strokeWidth: 0,
      fill: "#f3574a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 33h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1ZM54 33h-15c-.55 0-1 .45-1 1s.45 1 1 1h15c.55 0 1-.45 1-1s-.45-1-1-1ZM34 28h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1ZM38 29c0 .55.45 1 1 1h15c.55 0 1-.45 1-1s-.45-1-1-1h-15c-.55 0-1 .45-1 1ZM34 38h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1ZM54 38h-15c-.55 0-1 .45-1 1s.45 1 1 1h15c.55 0 1-.45 1-1s-.45-1-1-1ZM34 43h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1ZM54 43h-15c-.55 0-1 .45-1 1s.45 1 1 1h15c.55 0 1-.45 1-1s-.45-1-1-1ZM34 48h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1ZM54 48h-15c-.55 0-1 .45-1 1s.45 1 1 1h15c.55 0 1-.45 1-1s-.45-1-1-1Z",
    style: {
      strokeWidth: 0,
      fill: "#d1d3d4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.e2a2b1c0d2613bddf8454f96d92d1c83.svg";
export { ForwardRef as ReactComponent };